import type { ReactNode } from "react";
import { TkLogo } from "./Logo";

// Logo-only header for focused flows (checkout, payment result) that
// render without the site nav. `center` and `end` are free slots.
export function MinimalHeader({ center, end }: { center?: ReactNode; end?: ReactNode }) {
  return (
    <header className="tk-mhead">
      <div className="tk-mhead__inner">
        <div className="tk-mhead__side">
          <TkLogo />
        </div>
        {center != null && <div className="tk-mhead__center">{center}</div>}
        <div className="tk-mhead__side tk-mhead__side--end">{end}</div>
      </div>
    </header>
  );
}
